import { render, staticRenderFns } from "./SendMessageTemplateModal.vue?vue&type=template&id=c98b22aa&"
import script from "./SendMessageTemplateModal.vue?vue&type=script&lang=js&"
export * from "./SendMessageTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageTemplateModal.vue?vue&type=style&index=0&id=c98b22aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports